import axios from "axios";
import * as types from '../constants/ActionTypes'
import { toast } from 'react-toastify';


// Url's
// const getOrderFulfillmentListUrl = `${process.env.REACT_APP_API_URL}api/csa-app/order-awaiting-acknowledge`;
// const getOrderPickSlipUrl = `${process.env.REACT_APP_API_URL}api/csa-app/fetch-pickslips`;
// const getOrderAckowledgeUrl = `${process.env.REACT_APP_API_URL}api/csa-app/order-acknowledgement-details`;
// const getOrderAcknowledgeSaveUrl = `${process.env.REACT_APP_API_URL}api/csa-app/order-acknowledgement-save`;
// const getProductDetailsUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-product-details`;
// const savePackUrl = `${process.env.REACT_APP_API_URL}api/csa-app/save-packslip-data`;

const getOrderFulfillmentListUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder/order-awaiting-acknowledge`;
const getOrderPickSlipUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder/fetch-pickslips`;
const getOrderAckowledgeUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder/order-acknowledgement-details`;
const getOrderAcknowledgeSaveUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder/order-acknowledgement-save`;
const getProductDetailsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder/get-product-details`;
const savePackUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder/save-packslip-data`;

// Actions
const orderFulfillmentListRequested = () => ({
    type: types.ORDERFULFILLMENTLIST_REQUEST
  });

const orderListFulfillmentSuccess = data => ({
  type: types.ORDERFULFILLMENTLIST_SUCCESS,
  data
});

const orderFulfillmentListFailure = error => ({
  type: types.ORDERFULFILLMENTLIST_FAILURE,
  error
});

//order acknowledge

const orderAcknowledgeListRequested = () => ({
  type: types.ORDERACKNOWLEDGELIST_REQUEST
});

const orderAcknowledgeListSuccess = data => ({
type: types.ORDERACKNOWLEDGELIST_SUCCESS,
data
});

const orderAcknowledgeListFailure = error => ({
type: types.ORDERACKNOWLEDGELIST_FAILURE,
error
});

//order pickslip

const orderPickSlipListRequested = () => ({
  type: types.ORDERPICKSLIPLIST_REQUEST
});

const orderPickSlipListSuccess = data => ({
type: types.ORDERPICKSLIPLIST_SUCCESS,
data
});

const orderPickSlipListFailure = error => ({
type: types.ORDERPICKSLIPLIST_FAILURE,
error
});

const orderAcknowledgeRequested = () => ({
  type: types.SUBMITORDERACKNOWLEDGE_REQUEST
});

const orderAcknowledgeSuccess = data => ({
  type: types.SUBMITORDERACKNOWLEDGE_SUCCESS,
  data
});
  
const orderAcknowledgeFailure = error => ({
  type: types.SUBMITORDERACKNOWLEDGE_FAILURE,
  error
});


//produ details

const productDetailsRequested = () => ({
  type: types.PRODUCTDETAILS_REQUEST
});

const productDetailsSuccess = data => ({
type: types.PRODUCTDETAILS_SUCCESS,
data
});

const productDetailsFailure = error => ({
type: types.PRODUCTDETAILS_FAILURE,
error
});

//save pack 

const savePackRequested = () => ({
  type: types.SAVEPACK_REQUEST
});

const savePackSuccess = data => ({
type: types.SAVEPACK_SUCCESS,
data
});

const savePackFailure = error => ({
type: types.SAVEPACK_FAILURE,
error
});

// API 
export const getOrderFulfillmentList = (connection_id) => {
  
  return dispatch => {
    dispatch(orderFulfillmentListRequested());
     axios.get(getOrderFulfillmentListUrl, {
       params: {
         connection_id
       },
     })

    // axios.post(getOrderFulfillmentListUrl, {
    //   connection_id
    //         },{
    //         headers: {
    //           'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //           //'Content-Type': 'application/json; charset=UTF-8'
    //         },
    //       })
      .then(res => {
        if (res.status === 200) {
       
          dispatch(orderListFulfillmentSuccess(res.data));
        } else if (res.data.ack === "Failure") {

          dispatch(orderFulfillmentListFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


//product details
export const getProductDetails = (connection_id,fo_no) => {
  return dispatch => {
    dispatch(productDetailsRequested());
//     axios.post(getProductDetailsUrl, {
// connection_id,fo_no
//       },{
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//         //'Content-Type': 'application/json; charset=UTF-8'
//       },
//     })
axios.get(getProductDetailsUrl, {
  params: {
    connection_id,
    fo_no
  },
})
      .then(res => {
       
        if (res.status === 200) {
       
          dispatch(productDetailsSuccess(res.data));
        } else if (res.data.ack === "Failure") {

          dispatch(productDetailsFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const getOrderAckowledge=(connection_id)=>{
   return dispatch => {
    dispatch(orderAcknowledgeListRequested());

    // axios.post(getOrderAckowledgeUrl,{
    //   connection_id

    // },{
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //     //'Content-Type': 'application/json; charset=UTF-8'
    //   },
    // })
    axios.get(getOrderAckowledgeUrl, {
      params: {
        connection_id
      },
    })
    .then(res => {
      
         if (res.status === 200) {
        
           
           dispatch(orderAcknowledgeListSuccess(res.data));
         } else if (res.data.ack === "Failure") {
 
           dispatch(orderAcknowledgeListFailure(res.data.status));
         } 
       })
       .catch(err => {
           throw err;
         // dispatch(addTodoFailure(err.message));
       });
  }


}

//get pickslip

export const getPickSlip=(connection_id,fo_no)=>{
 

  return dispatch => {
   dispatch(orderPickSlipListRequested());

  //  axios.post(getOrderPickSlipUrl,{
  //    connection_id,
  //    fo_no

  //  },{
  //    headers: {
  //      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  //      //'Content-Type': 'application/json; charset=UTF-8'
  //    },
  //  })
  axios.get(getOrderPickSlipUrl, {
    params: {
      connection_id,
      fo_no
    },
  })
   .then(res => {
        if (res.status === 200) {
          
          dispatch(orderPickSlipListSuccess(res.data));
        } else if (res.data.ack === "Failure") {

          dispatch(orderPickSlipListFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
 }


}

//save order acknowledge


// API
export const saveOrderAcknowledge = (options) => {
  return dispatch => {
    dispatch(orderAcknowledgeRequested());
    axios.post(getOrderAcknowledgeSaveUrl, options, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
          //'Content-Type': 'application/json; charset=UTF-8'
        },
    })
      .then(res => {
        if (res.status === 200) {
          dispatch(orderAcknowledgeSuccess(res.data.results));
         toast.error(`Sucessfully updated`);
        } else if (res.data.ack === "Failure") {
          //toast.error(`Failed - ${res.data.status.message}`);
          dispatch(orderAcknowledgeFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
//save pack save 

export const savePack= (options) => {
  return dispatch => {
    dispatch(savePackRequested());
    axios.post(savePackUrl, options, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
          //'Content-Type': 'application/json; charset=UTF-8'
        },
    })
    
      .then(res => {
        if (res.status === 200 && res.data.status === true) {
          dispatch(savePackSuccess(res.data.results));
         toast.error(`Sucessfully updated`);
        } else if (res.data.status === false) {
          toast.error(`Failed - ${res.data.msg}`);
          dispatch(savePackFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

